import { UrgencyLevel } from '@wm-front/admin/graphql'

declare const $localize: any

export function translateUrgency(urgency: UrgencyLevel): string {
  switch (urgency) {
    case UrgencyLevel.Urgent:
      return $localize`:Label | Urgent label@@i18nUrgencyUrgentLabel:Urgent`
    case UrgencyLevel.InTheWeek:
      return $localize`:Label | In the week label@@i18nUrgencyInTheWeekLabel:Cette semaine`
    case UrgencyLevel.ForTheNextVisit:
      return $localize`:Label | Next visit label@@i18nUrgencyForNextVisitLabel:Prochaine visite`
  }
}
